import React from 'react';
import DfbHeadline from '../ui-kit/dfb_headline';
import DfbRte from '../ui-kit/dfb_rte';
import Section from "./section"

const MExcerpt = (props) => {
  return (
    <Section
      baseClass="m-Excerpt"
      defaultBgColor={'grey'}
      data={props.data}
    >
      <div className="m-Excerpt-wrapper">
        <div className="m-Excerpt-container">
          {props.data.headline &&
            <DfbHeadline headline={props.data.headline} headline_level="h2" add_class="m-Excerpt-headline" />
          }
          {props.data.text &&
            <DfbRte text={props.data.text} add_class="m-Excerpt-rte" />
          }
        </div>
      </div>
    </Section>
  );
}

export default MExcerpt;
